/**
 * Un bug chrome fait que les svg avec use «externe», donc dans un fichier accédé via un url, ne s'affiche pas systématiquement.
 * Pour palier ce bug, on récupère tous les svg>use de la page et on place tous les symboles des fichiers svg visés dans un conteneur.
 * Cela permet à Chrome de les afficher correctement.
 */

if (Object.hasOwn(window, 'chrome')) {
  /**
   * Transforme les use externe en use interne.
   * @param {Element} node
   * @return {Promise<undefined>}
   */
  async function processUses(node = document) {
    const uses = node.querySelectorAll('use[href*=".svg#"]');
    if (uses.length === 0) {
      return;
    }
    const alreadyFetched = new Map();
    for (let i = 0; i < uses.length; i++) {
      const useEl = uses[i];
      const href = useEl.getAttribute('href');
      const [spriteUrl, id] = href.split('#');
      if (!alreadyFetched.has(spriteUrl)) {
        const res = await fetch(spriteUrl);
        if (!res.ok) {
          continue;
        }
        const text = await res.text();
        alreadyFetched.set(spriteUrl, new DOMParser().parseFromString(text, 'text/html'));
      }
      if (alreadyFetched.has(spriteUrl) && alreadyFetched.get(spriteUrl).querySelector(`svg symbol[id="${id}"]`)) {
        /**
         * @type SVGElement
         */
        const symbol = alreadyFetched.get(spriteUrl).querySelector(`svg symbol[id="${id}"]`);
        useEl.closest('svg').setAttribute('viewBox', symbol.getAttribute('viewBox'))
        useEl.replaceWith(...symbol.cloneNode(true).children);
      }
    }
  }

  /**
   * Observe les changements dans le DOM pour remplacer les use externe par des use interne.
   * @type {MutationObserver}
   */
  const observer = new MutationObserver(async (mutations) => {
    for (const mutation of mutations) {
      for (const node of mutation.addedNodes) {
        if (!(node instanceof Element)) {
          continue;
        }
        if (node.querySelector && node.querySelector('use[href*=".svg#"]')) {
          await processUses(node);
        } else if (node.tagName === 'use' && node.getAttribute('href')?.includes('.svg#')) {
          await processUses(node.parentNode || document);
        }
      }
    }
  });

  document.addEventListener('DOMContentLoaded', async () => {
    await processUses();
    observer.observe(document.body, {childList: true, subtree: true});
  });
}